import axios from "axios";
import { Message } from "@arco-design/web-vue";

const myAxios = axios.create({
  timeout: 60000,
  withCredentials: true,
});

myAxios.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

myAxios.interceptors.response.use(
  function (response) {
    const { data } = response;

    if (data.code === 40100) {
      const responseUrl = String(response.request?.responseURL || "");
      if (!responseUrl.includes("user/get/login")) {
        window.dispatchEvent(
          new CustomEvent("komeic:auth-required", {
            detail: { returnTo: `${window.location.pathname}${window.location.search}${window.location.hash}` },
          })
        );
      }
    }

    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default myAxios;
